module.exports = __webpack_public_path__ + "media/icons/favicons/favicon-96x96-fbee311cdaffccb7d9875293cacc4ff2.png";